import { get } from 'svelte/store'
import { t } from 'svelte-i18n'
import { ButtonType } from '@repo/commons/components'
import { confirmationStore } from '@repo/commons/store'

export const confirmDelete = (title: string, message: string): Promise<boolean> => {
	const translate = get(t)

	return confirmationStore.show({
		title,
		message,
		confirmButtonType: ButtonType.DESTRUCTIVE,
		confirmText: translate('ContextMenu.delete'),
		cancelText: translate('FORM.cancel')
	})
}
